// extracted by mini-css-extract-plugin
export default {"biobar-button":"styles_biobar-button__P0JuQ","biobar-button-outline":"styles_biobar-button-outline__oHnn6"};